export default __webpack_public_path__ + "static/media/youtube.578d8487.png";